import { SHOW_KEYBOARD, GENERATE_DEVICE_ID, STORE_HISTORY, GENERATE_MOBILE_ID, STORE_CURRENT_ARTWORK_ID } from '../constants/appConstants';

const initialState = { showKeyboard: false, webosDeviceId: null, history: null, mobileId: null, current: null};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_KEYBOARD:
      return { ...state, showKeyboard: action.payload };
    case GENERATE_DEVICE_ID:
      return { ...state, webosDeviceId: action.payload };
    case GENERATE_MOBILE_ID:
      return { ...state, mobileId: action.payload };
    case STORE_HISTORY:
      return { ...state, history: action.payload };
    case STORE_CURRENT_ARTWORK_ID:
      return {...state, current: action.payload};
    default:
      return state;
  }
};

export default reducer;
